




























import { Component, Vue } from 'vue-property-decorator';
import ApiRoutes from '@/logic/ApiRoutes';
import ApiHandler from '@/logic/ApiHandler';
import Host from '@/types/Host';
import Performance from '@/types/Performance';
import GlobalEvents from '@/logic/GlobalEvents';
import PullRefresh from '@/components/functional/PullRefresh.vue';

@Component({
    components: {
        PullRefresh
    }
})
export default class HostSelection extends Vue {

    private loading: boolean = false;
    private hosts: Host[] = [];

    private mounted() {
        // Clear current host
        this.$store.dispatch('settings/clearHost');

        this.fetchHosts();

        // Attach refresh listener
        GlobalEvents.$on('local-refresh', () => {
            this.fetchHosts()
                .then(() => GlobalEvents.$emit('local-refresh-done'));
        });
    }

    private beforeDestroy() {
        // Detach global listeners
        GlobalEvents.$off('local-refresh');
    }

    private selectHost(host: Host) {
        this.$store.dispatch('settings/setHost', host);
        this.$router.push('/home');
    }

    private async fetchHosts() {
        this.loading = true;

        // // Get host pin codes for all public performances
        // const data: Performance[] = await ApiHandler.request(ApiRoutes.getPerformancesRequest());
        // const set: Set<number> = new Set();
        // data.forEach((performance) => {
        //     set.add(parseInt(performance.host_pin, 10));
        // });

        // // Clear hosts
        // this.hosts.length = 0;

        // // Load hosts
        // set.forEach((hostPin) => {

        //     ApiHandler.request(ApiRoutes.getLoginRequest(hostPin)).then((host) => {
        //         this.hosts.push(host);
        //     });
        // });

        this.hosts = await ApiHandler.request(ApiRoutes.getAvailableHostsRequest());

        this.loading = false;
    }
}
